module.exports = __webpack_public_path__ + "fonts/notosans-regular-web.0d368cf.woff2";